<template xmlns="http://www.w3.org/1999/html">
    <div class="wrap" v-if="show">
        <div class="notice">
            <div class="noticeItem">您所填的信息仅用于审批借款额度，资料将被加密保护</div>
        </div>
        <div class="x-money">
            <input v-model="defaultMoney" type="number" class="x-money_number"
                   onkeyup="this.value=this.value.replace(/\D|^0/g,'')"/>
            <div class="x-money_edit">
                <img src="@/assets/img/tcHelp/edit.png" style="width:100%;height:100%;"/>
            </div>
            <div class="x-money_btn" @click="allLoan">
                全部借出
            </div>
        </div>
        <div class="content">
            <div class="user_info" style="margin-top: 0">
                <div class="choose_user_info">
                    <div style="background: #ffffff;border-radius: 4px;">
                        <!-- 借款期限 -->
                        <div class="user_box user_box_bot" @click="showDatePicker = true">
                            <div>借多久</div>
                            <div class="user_box_right">
                                <span v-if="userDate==''" class="choose_color">请选择</span>
                                <span v-else>{{userDate}}期</span>
                                <img src="@/assets/img/tcHelp/right_tip.png" alt=""/>
                            </div>
                        </div>
                        <van-popup v-model="showDatePicker" round position="bottom">
                            <van-picker show-toolbar :columns="columnsDate" @cancel="showDatePicker = false"
                                        @confirm="onConfirmDate"/>
                        </van-popup>
                        <!-- 借款金额 -->
                        <div class="column">
                            <div style="display: flex;justify-content: space-between;margin-bottom: 0.1rem;">
                                <div>怎么还</div>
                                <div>{{userMoney}}元</div>
                            </div>
                            <div class="desc">温馨提示：最终放款金额、借款利率以机构审核为准</div>
                        </div>
                    </div>
                    <div style="background: #ffffff;margin-top: 0.1rem;border-radius: 4px;" class="column"
                         v-if="productDetail.applyConditions">
                        <div style="margin-bottom: 5px;">机构信息</div>
                        <div v-for="(item,index) in applyConditions" :key="index" class="desc">
                            {{item}}
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="agreement">
                <!--<div>我已阅读并同意<a :href="agreement.url">{{agreement.name}}</a></div>-->
                <div class="agree">
                    <div v-if="xy_selected" class="img">
                        <img src="@/assets/img/vip/selected.png"
                             style="width: 100%;height: 100%;"
                             @click="xy_selected=!xy_selected">
                    </div>
                    <div v-else class="img">
                        <img src="@/assets/img/vip/no_select.png" style="width: 100%;height: 100%;"
                             @click="xy_selected=!xy_selected">
                    </div>
                    我已同意并接受<span style="color: #3A3A3A;" @click="redirectXy">{{agreement.name}}</span>
                </div>
            </div>

            <div class="btn" @click="postOrder">立即申请</div>
        </div>

        <Loading :isShow="showLoading"></Loading>
    </div>
</template>

<script>
    import Loading from '@/components/loading';

    export default {
        components: {
            Loading,
        },
        data() {
            return {
                show:false,
                showLoading: false,
                columnsDate: [],
                userDate: "", //用户借款期限
                showDatePicker: false,
                defaultMoney: "30000",
                productDetail: {},
                applyConditions:[],
                agreement: "",
                xy_selected: false,
            }
        },
        created() {
            this.productId = this.$route.query.productId;

        },
        mounted(){
            this.checkPostOrder();
        },
        computed: {
            userMoney() {
                console.log(this.userDate + "   " + this.productDetail.interestRateStart + "  " + this.defaultMoney)
                if (this.userDate && this.userDate && this.productDetail.interestRateStart) {
                    // (金额/期数)*(1+rate/100)
                    return ((this.defaultMoney / this.userDate) * (1 + this.productDetail.interestRateStart / 100)).toFixed(2);
                }
                return ''
            }
        },
        methods: {
            checkPostOrder() {
                let param = {
                    productId: this.productId
                }
                this.showLoading = true;
                this.$get('/app/api/v1/order/check/postOrder', param)
                    .then(res => {
                        if (res.code == 200) {
                            this.showLoading = false;
                            console.log(res.data)
                            if(res.data){
                                window.location.href = res.data;
                            }else{
                                this.show=true;
                                this.getProductDetail();
                            }
                        } else {
                            this.show=true;
                            this.showLoading = false;
                            this.util.toast({msg: res.message})
                        }
                    })
                    .catch(error => {
                    });
            },
            getProductDetail() {
                let param = {
                    productId: this.productId
                }
                this.showLoading = true;
                this.$get('/app/api/v1/product/queryById', param)
                    .then(res => {
                        if (res.code == 200) {
                            this.showLoading = false;
                            this.productDetail = res.data;
                            var agreement=res.data.agreement;
                            if(agreement){
                                this.agreement=JSON.parse(agreement);
                            }
                            this.util.title(this.productDetail.name);
                            var stagingSetting = JSON.parse(this.productDetail.stagingSetting);
                            this.columnsDate = stagingSetting.map((item, index) => ({
                                num: item.period,
                                text: item.period + '期'
                            }));
                            if(this.productDetail.applyConditions){
                                this.applyConditions=this.productDetail.applyConditions.split("；");
                            }
                            this.userDate = this.columnsDate[0].num;
                        } else {
                            this.showLoading = false;
                            this.util.toast({msg: res.message})
                        }
                    })
                    .catch(error => {
                    });
            }, allLoan() {
                this.defaultMoney = this.productDetail.limitEnd / 100;
            }, onConfirmDate(value) {
                this.userDate = value.num;
                this.showDatePicker = false;
            }, postOrder() {
                if (this.agreement) {
                    if (!this.xy_selected) {
                        this.util.toast({msg: "请先勾选协议"});
                        return;
                    }
                }
                if (this.defaultMoney == "") {
                    this.util.toast({msg: "申请金额不能为空"})
                    return;
                }
                if (this.userDate == "") {
                    this.util.toast({msg: "申请期数不能为空"})
                    return;
                }
                if (this.userCity == "") {
                    this.util.toast({msg: "所在城市不能为空"})
                    return;
                }

                let orderParam = {
                    productId: this.productId
                };
                this.$post("/app/api/v1/order/postOrder", orderParam)
                    .then((res) => {
                        if (res.code == 200) {
                            console.log(res.data.postOrderSuccess)
                            if (res.data.postOrderSuccess) {
                                this.util.toast({msg: "申请成功,可前往我的-申请中查看"})
                            }
                            window.location.href = res.data.pageUrl;
                        } else {
                            this.util.toast({msg: res.message})
                        }
                    });
            },redirectXy(){
                window.location.href = this.agreement.url;
            }


        }

    }
</script>
<style scoped>

    [v-cloak] {
        display: none;
    }

    .wrap {
        height: 100%;
        background: #F5F5F5;
        font-family: PingFangSC-Medium, PingFang SC;
    }

    .content {
        width: 100%;
        margin: 0.1rem auto;
    }

    .user_info {
        margin-top: 0.1rem;
    }

    .choose_user_info {
        padding: 0 0.15rem;
    }

    .user_box {
        width: 100%;
        height: 0.6rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-weight: 500;
        color: #2F2F2F;
        font-size: 0.16rem;
        padding: 0.1rem;
    }

    .user_box_bot {
        border-bottom: 0.01rem solid #f5f5f5;
    }

    .user_box_right {
        display: flex;
        align-items: center;
    }

    .user_box_right img {
        width: 0.1rem;
        height: 0.1rem;
        margin-left: 0.1rem;
    }

    .choose_color {
        color: #999999;
    }

    .van-index-bar .van-cell {
        width: 100%;
    }

    .column{
        padding: 0.13rem 0.1rem;
        font-weight: 500;
        color: #2F2F2F;
        font-size: 0.16rem;
    }

    .column .desc{
        font-size: 0.12rem;
        font-weight: 400;
        color: #999999;
        line-height: 0.2rem;
    }
    .btn {
        /* margin-top: 0.1rem; */
        width: 90%;
        height: 0.5rem;
        font-size: 0.17rem;
        color: #ffffff;
        font-weight: bold;
        line-height: 0.5rem;
        text-align: center;
        background: #2B66FF;
        border-radius: 0.25rem;
        margin: 0.1rem auto 0;
    }

    .x-money {
        width: 100vw;
        height: 39.73vw;
        background-image: url("../../assets/img/tcHelp/money_bg.png");
        background-size: contain;
        background-repeat: no-repeat;
        position: relative;
    }

    .x-money_number {
        font-size: 0.5rem;
        font-family: DINAlternate-Bold, DINAlternate;
        font-weight: bold;
        color: #FFFFFF;
        position: absolute;
        top: 0.45rem;
        left: 0.39rem;
        width: 1.8rem;
        background: none;
        outline: none;
        border: none;
    }

    .x-money_edit {
        width: 0.14rem;
        height: 0.14rem;
        position: absolute;
        top: 0.8rem;
        right: 1.2rem;
    }

    .x-money_btn {
        width: 0.8rem;
        height: 0.28rem;
        background: #E6ECFF;
        border-radius: 0.15rem;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0.14rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #4E78FD;
        position: absolute;
        top: 0.6rem;
        right: 0.14rem;
    }

    .notice {
        box-sizing: border-box;
        overflow: hidden;
        width: 100vw;
        height: 8.266666666vw;
        background-image: url("../../assets/img/tcHelp/swiper_bg.png");
        background-size: cover;
        background-repeat: no-repeat;
        padding-left: 0.1rem;
    }

    .noticeItem {
        height: 0.31rem;
        display: flex;
        margin-left: 8%;
        align-items: center;
        font-size: 0.12rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #4E78FD;
        margin-top: 1px;
    }

    .agree {
        display: flex;
        padding: 0.11rem 0.1rem 0rem 0.15rem;
        font-size: 0.12rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #A3A3A3;
    }

    .agree .img {
        width: 0.14rem;
        height: 0.14rem;
        margin-right: 4px;
        margin-top: 1px;
    }
</style>
